// in src/App.js
import * as React from 'react'
import {
  required,
  Admin,
  Resource,
  ListGuesser,
  Create,
  TabbedForm,
  FormTab,
  ReferenceInput,
  SelectInput,
  TextInput
} from 'react-admin'
import jsonServerProvider from 'ra-data-json-server'

const dataProvider = jsonServerProvider('https://jsonplaceholder.typicode.com')
const App = () => (
  <Admin dataProvider={dataProvider}>
    <Resource name="users" list={ListGuesser} create={ListCreate} />
  </Admin>
)

const ListCreate = (props) => {
  return (
    <Create {...props}>
      <TabbedForm>
        <FormTab label="summary">
          <TextInput source="title" validate={required()} />
          <TextInput multiline source="body" validate={required()} />
        </FormTab>
        <FormTab label="data">
          <ReferenceInput
            source="userId"
            reference="users"
            validate={required()}
          >
            <SelectInput optionText="name" />
          </ReferenceInput>
        </FormTab>
      </TabbedForm>
    </Create>
  )
}

export default App
